module.exports = __webpack_public_path__ + "static/media/dashboard.fa82e75c.png";